import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formatter, getDateFormat, getDateTimeFormat} from 'helpers';

import {DEFAULT_TIMEZONE} from 'helpers/constants';

const FormattedDate = ({
  date,
  emptyText,
  isDateTime,
  isUtc,
  portalSettings,
  timezone,
  ignoreTimezone,
}) => {
  const format = isDateTime
    ? getDateTimeFormat(portalSettings)
    : getDateFormat(portalSettings);

  return !ignoreTimezone
    ? formatter.formatDate(date, timezone, format, emptyText, isUtc)
    : formatter.formatDateWithoutTimezone(date, format, emptyText);
};

FormattedDate.defaultProps = {
  date: null,
  emptyText: '',
  ignoreTimezone: false,
  isDateTime: false,
  isUtc: false,
  timezone: DEFAULT_TIMEZONE,
};

FormattedDate.propTypes = {
  date: PropTypes.string,
  emptyText: PropTypes.any,
  isDateTime: PropTypes.bool,
  isUtc: PropTypes.bool,
  portalSettings: PropTypes.object.isRequired,
  timezone: PropTypes.string,
  ignoreTimezone: PropTypes.bool,
};

const mapStateToProps = state => ({
  portalSettings: state.portal.portalSettings,
  timezone: state.user.timezone,
});

export default connect(mapStateToProps)(FormattedDate);



// WEBPACK FOOTER //
// ./src/components/Common/Format/FormattedDate.js